import {
  Box,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import {
  Business as OrganizationIcon,
  LocalHospital as DoctorIcon,
  Accessibility as PatientIcon,
  Badge as StaffIcon,
  CorporateFare as SystemIcon,
} from "@mui/icons-material";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { fetchOrganizations } from "../redux/organization/organizationAction";
import { fetchAdminCountRequest } from "../redux/dashboard/dashboardAction";
import ReusableTable from "../common/table/CommonTable";
import StatCard from "./admindashboard/StatCard";

const SuperAdminDashboard = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  // Selectors
  const organizationState = useSelector(
    (state) => state?.organization?.fetchListOrganizations || {}
  );
  const adminState = useSelector(
    (state) => state?.dashboard?.fetchAdminCount || {}
  );

  const organizations = organizationState.data?.data || [];
  const countData = adminState?.count?.count || {};

  useEffect(() => {
    const payload = {
      pageNo: 1,
      pagesize: 10,
      pagination_required: true,
    };
    dispatch(fetchOrganizations(payload));
    dispatch(fetchAdminCountRequest());
  }, [dispatch]);

  const systemStats = [
    {
      title: "Total Organizations",
      count: organizations.length || 0,
      icon: <OrganizationIcon sx={{ fontSize: 40 }} />,
      color: "#129bab",
    },
    {
      title: "Active Doctors",
      count: countData.doctorCount || 0,
      icon: <DoctorIcon sx={{ fontSize: 40 }} />,
      color: "#2196f3",
    },
    {
      title: "Total Staff",
      count: countData.staffsCount || 0,
      icon: <StaffIcon sx={{ fontSize: 40 }} />,
      color: "#ff9800",
    },
    {
      title: "Total Patients",
      count: countData.patientsCount || 0,
      icon: <PatientIcon sx={{ fontSize: 40 }} />,
      color: "#673ab7",
    },
  ];

  const orgColumns = [
    { id: "serial_no", label: "S.No", sortable: true },
    { id: "org_name", label: "Organization", sortable: true },
    { id: "hospital_name", label: "Hospital", sortable: true },
    { id: "email", label: "Email", sortable: true },
    { id: "phone", label: "Phone", sortable: true },
    {
      id: "status",
      label: "Status",
      render: (value) => (
        <Typography
          sx={{
            color: value === 1 ? "green" : "red",
            fontWeight: "bold",
          }}
        >
          {value === 1 ? "Active" : "Inactive"}
        </Typography>
      ),
    },
  ];

  const processedOrgData = useMemo(() => {
    return organizations.map((org, index) => ({
      ...org,
      serial_no: index + 1,
    }));
  }, [organizations]);

  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
          <SystemIcon sx={{ fontSize: 40, color: "#129bab", mr: 2 }} />
          <Typography variant="h4" fontWeight="bold">
            SuperAdmin Command Center
          </Typography>
        </Box>
      </motion.div>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        {systemStats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
            >
              <StatCard stat={stat} />
            </motion.div>
          </Grid>
        ))}
      </Grid>

      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          background: "white",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          Organization Overview
        </Typography>
        <ReusableTable
          columns={orgColumns}
          data={processedOrgData}
          isLoading={organizationState.loading}
          headerColor="#000"
          rowColor="#ffffff"
          withPagination={true}
          rowsPerPage={5}
        />
      </Paper>
    </Box>
  );
};

export default SuperAdminDashboard;
